import StorageIcon from '@mui/icons-material/Storage';
import CloudIcon from '@mui/icons-material/Cloud';
import WebIcon from '@mui/icons-material/Web';
import ApiIcon from '@mui/icons-material/Api';
import DnsIcon from '@mui/icons-material/Dns';
import BlockIcon from '@mui/icons-material/Block';

// Registry for UmlIconShape.iconKind -> {label, Icon}. 'none' is always first
// (icon-picker default/reset option, see UmlIconWidget.jsx) — draws no icon at
// all, just the caption/stereotype box. Small fixed v1 set; extend here when
// adding more kinds (no other file needs to change — UmlIconWidget just looks
// up whatever key is stored on the shape).
export const UML_ICON_SHAPE_ICONS = {
    none: { label: 'None', Icon: null },
    database: { label: 'Database', Icon: StorageIcon },
    externalSystem: { label: 'External System', Icon: CloudIcon },
    webApp: { label: 'Web App', Icon: WebIcon },
    webService: { label: 'Web Service', Icon: ApiIcon },
    server: { label: 'Server', Icon: DnsIcon },
};

// Fallback icon shown if a shape's iconKind isn't a known key (e.g. legacy data,
// typo) — never render nothing silently, that looks like a rendering bug rather
// than an unrecognized value.
export const UML_ICON_SHAPE_FALLBACK = { label: 'Unknown', Icon: BlockIcon };

/**
 * @param {string} iconKind
 * @returns {{label: string, Icon: React.ComponentType|null}}
 */
export function getIconInfo(iconKind) {
    return UML_ICON_SHAPE_ICONS[iconKind] || UML_ICON_SHAPE_FALLBACK;
}
